<template>
  <section class="hiw">
    <div class="hiw__inner">

      <h2 class="hiw__title">{{ $lang.app.how_it_works.title }}</h2>
      <p class="hiw__subtitle">{{ $lang.app.how_it_works.des }}</p>

      <div class="hiw__steps">

        <!-- Step 1 -->
        <div class="hiw__step">
          <div class="hiw__step-top">
            <div class="hiw__icon hiw__icon--blue">
              <i class="bi-pencil-fill"></i>
            </div>
            <span class="hiw__num">01</span>
          </div>
          <h3 class="hiw__step-title">{{ $lang.app.how_it_works.filling_application.title }}</h3>
          <p class="hiw__step-desc">{{ $lang.app.how_it_works.filling_application.des }}</p>
        </div>

        <div class="hiw__connector" aria-hidden="true">
          <i class="bi-chevron-double-right"></i>
        </div>

        <!-- Step 2 -->
        <div class="hiw__step">
          <div class="hiw__step-top">
            <div class="hiw__icon hiw__icon--purple">
              <i class="bi-hourglass-split"></i>
            </div>
            <span class="hiw__num">02</span>
          </div>
          <h3 class="hiw__step-title">{{ $lang.app.how_it_works.consideration_application.title }}</h3>
          <p class="hiw__step-desc">{{ $lang.app.how_it_works.consideration_application.des }}</p>
        </div>

        <div class="hiw__connector" aria-hidden="true">
          <i class="bi-chevron-double-right"></i>
        </div>

        <!-- Step 3 -->
        <div class="hiw__step">
          <div class="hiw__step-top">
            <div class="hiw__icon hiw__icon--green">
              <i class="bi-mortarboard-fill"></i>
            </div>
            <span class="hiw__num">03</span>
          </div>
          <h3 class="hiw__step-title">{{ $lang.app.how_it_works.enrollment.title }}</h3>
          <p class="hiw__step-desc">{{ $lang.app.how_it_works.enrollment.des }}</p>
        </div>

      </div>
    </div>
  </section>
</template>

<style scoped>
/* ───── Section ───── */
.hiw {
  padding: 72px 0 80px;
  background: #fff;
}
.hiw__inner {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 48px;
}

/* ───── Heading ───── */
.hiw__title {
  text-align: center;
  font-size: 32px;
  font-weight: 800;
  color: #0a183c;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
}
.hiw__subtitle {
  text-align: center;
  font-size: 16px;
  color: #5a6a8a;
  margin: 0 0 56px;
}

/* ───── Steps row ───── */
.hiw__steps {
  display: flex;
  align-items: flex-start;
  gap: 0;
}

/* ───── Connector ───── */
.hiw__connector {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 28px;
  color: rgba(21, 101, 192, 0.3);
  font-size: 28px;
  width: 64px;
}

/* ───── Single step ───── */
.hiw__step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: linear-gradient(160deg, #f0f4fb 0%, #e8eef8 100%);
  border: 1px solid rgba(21, 101, 192, 0.1);
  border-radius: 20px;
  padding: 36px 28px 32px;
  box-shadow: 0 4px 24px rgba(10, 24, 60, 0.06);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}
.hiw__step:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(21, 101, 192, 0.13);
}

/* ───── Top row: icon + number ───── */
.hiw__step-top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.hiw__num {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 12px;
  font-weight: 800;
  color: #1565c0;
  background: #fff;
  border: 2px solid rgba(21, 101, 192, 0.25);
  border-radius: 8px;
  line-height: 1;
  padding: 4px 6px;
  letter-spacing: 0.5px;
}

/* ───── Icons ───── */
.hiw__icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  color: #fff;
  flex-shrink: 0;
}
.hiw__icon--blue {
  background: linear-gradient(135deg, #1e88e5, #1565c0);
  box-shadow: 0 10px 24px rgba(21, 101, 192, 0.38);
}
.hiw__icon--purple {
  background: linear-gradient(135deg, #7c4dff, #512da8);
  box-shadow: 0 10px 24px rgba(81, 45, 168, 0.38);
}
.hiw__icon--green {
  background: linear-gradient(135deg, #43a047, #2e7d32);
  box-shadow: 0 10px 24px rgba(46, 125, 50, 0.38);
}

/* ───── Text ───── */
.hiw__step-title {
  font-size: 18px;
  font-weight: 700;
  color: #0a183c;
  margin: 0 0 12px;
  line-height: 1.3;
}
.hiw__step-desc {
  font-size: 15px;
  color: #5a6a8a;
  line-height: 1.65;
  margin: 0;
}

/* ───── Responsive ───── */
@media screen and (max-width: 1100px) {
  .hiw__inner {
    padding: 0 32px;
  }
  .hiw__connector {
    font-size: 22px;
    width: 44px;
  }
}
@media screen and (max-width: 768px) {
  .hiw {
    padding: 52px 0 60px;
  }
  .hiw__inner {
    padding: 0 20px;
  }
  .hiw__title {
    font-size: 26px;
  }
  .hiw__subtitle {
    font-size: 15px;
    margin-bottom: 36px;
  }
  .hiw__steps {
    flex-direction: column;
    gap: 0;
  }
  .hiw__step {
    flex-direction: row;
    text-align: left;
    align-items: flex-start;
    gap: 20px;
    padding: 24px 22px;
  }
  .hiw__step-top {
    margin-bottom: 0;
    flex-shrink: 0;
  }
  .hiw__connector {
    width: 100%;
    padding: 8px 0 8px 50px;
    justify-content: flex-start;
    font-size: 20px;
    transform: rotate(90deg) scaleX(0.6);
    transform-origin: center;
    height: 40px;
  }
  .hiw__icon {
    width: 64px;
    height: 64px;
    font-size: 28px;
    border-radius: 16px;
  }
}
@media screen and (max-width: 479px) {
  .hiw__title {
    font-size: 22px;
  }
  .hiw__icon {
    width: 54px;
    height: 54px;
    font-size: 24px;
    border-radius: 13px;
  }
  .hiw__step-title {
    font-size: 16px;
  }
  .hiw__step-desc {
    font-size: 14px;
  }
}
</style>
